import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Descriptions, Divider, Drawer, message, Spin} from 'antd';
import Media from 'pages/health/Media';

import {findTreatmentById} from 'services/TreatmentService';
import {handleError} from 'utils/MessageUtils';

const TreatmentInfo = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {treatmentId, viewing, setViewing, setReloading} = props;
  const [loading, setLoading] = useState(false);
  const [treatment, setTreatment] = useState();

  useEffect(() => {
    if (viewing && treatmentId?.length > 0) {
      setLoading(true);
      findTreatmentById(headers, treatmentId)
        .then((res) => {
          setTreatment(res.data);
        })
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [viewing]);

  const onClose = () => {
    setTreatment(null);
    setViewing(false);
    setReloading(true);
  };

  return (
    <Drawer
      title={intl.messages['common.detail']}
      width={800}
      onClose={onClose}
      visible={viewing}
      destroyOnClose={true}
      bodyStyle={{paddingBottom: 80}}>
      <Spin spinning={loading}>
        <Descriptions
          bordered
          size='middle'
          style={{paddingTop: 10}}
          column={2}>
          <Descriptions.Item label={intl.messages['treatment.name']} span={2}>
            {treatment?.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['treatment.startTime']}>
            {treatment?.period?.start}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['treatment.endTime']}>
            {treatment?.period?.end}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['treatment.note']} span={2}>
            {treatment?.note}
          </Descriptions.Item>
        </Descriptions>

        <Divider />

        {treatmentId?.length > 0 && <Media treatmentId={treatmentId} />}
      </Spin>
    </Drawer>
  );
};

export default TreatmentInfo;

TreatmentInfo.propTypes = {
  treatmentId: PropTypes.string.isRequired,
  viewing: PropTypes.bool.isRequired,
  setViewing: PropTypes.func.isRequired,
  setReloading: PropTypes.func.isRequired,
};
